// eslint-disable-next-line require-await
export default [
  {
    // Manage firm:
    path: '/advisor/open-client-account/',
    name: 'openClientAccount',
    component: () => import('@advisor/components/clients/onBoarding/PersonalInfoADO'),
    meta: {riaComponent: 'ADO_OPEN_CLIENT_ACCOUNT'},
  },
];
